<template>
    <div class="w-full border rounded-md flex text-base shadow-md">
        <div class="flex flex-col justify-between font-semibold border-r h-full bg-gray-100 w-1/4 px-1">
            <div class="flex p-2 h-1/2 items-center border-b border-b-gray-300">
                <div class="flex justify-between items-center w-full">
                    <div>
                        <span class="tracking-widest">{{ postDate }}:</span> {{ postType }}
                    </div>
                    <div>
                        <button 
                            class="bg-none border border-dark-secondary hover:bg-dark-primary hover:text-gray-100 hover:shadow active:bg-dark-primary active:text-gray-400 text-white bg-dark-secondary whitespace-nowrap flex justify-center items-center rounded-md"
                        >
                            <EditSVG @click="openEdit" stroke="white" /> 
                        </button>
                    </div>
                </div>
            </div>
            <div class="flex justify-between items-center w-full p-2">
                <div >
                    Created by: {{ createdBy }}
                </div>
                <div>
                    <button v-if="isCreator"
                        class="bg-none border border-dark-secondary hover:bg-dark-primary hover:text-gray-100 hover:shadow active:bg-dark-primary active:text-gray-400 text-white bg-dark-secondary whitespace-nowrap flex justify-center items-center rounded-md"
                    >
                        <TrashSVG @click="archive" fill="white" stroke-color="white" /> 
                    </button>
                </div>
            </div>
        </div>
        <div class="p-2 w-3/4">
            {{ post.post_body }}
        </div>
        <base-modal 
        :is-form-visible="isEditable" @close="closeEdit"
            >
              <template v-slot:header>
                Edit Post
              </template>
              <template v-slot:body>
                    <ClientPostForm :post="post" add-or-edit="edit" @edit-post="editClientPost" :client="client" :user-options="userOptions" />
              </template>
        </base-modal>
    </div>
</template>

<script setup>
import { defineProps, defineEmits, computed, ref } from 'vue';
import { formatDateTwoDigitYear } from '@/composables/formatDate';
import EditSVG from '../svg-components/EditSVG.vue';
import TrashSVG from '../svg-components/TrashSVG.vue';
import { useStore } from 'vuex';
import { useToast } from 'vue-toast-notification';
import ClientPostForm from './ClientPostForm.vue';
import { updateClientPost, archiveClientPost } from '@/services/ClientPost';

const props = defineProps(['post', 'userOptions', 'client'])

const emit = defineEmits(['refetch-clients'])

const isEditable = ref(false)
const store = useStore()
const $toast = useToast()

const postDate = computed(() => {
    return formatDateTwoDigitYear(props.post.post_date)
})

const postType = computed(() => {
    return props.post.post_type ? props.post.post_type : ''
})

const createdBy = computed(() => {
    if(props.post.created_by){
        return `${props.post.created_by.first_name} ${props.post.created_by.last_name}`
    } else {
        return ''
    }
})

const isCreator = computed(() => {
    return store.state.auth.user.id == props.post.created_by.id
})

async function editClientPost(formData){
    const token = store.state.auth.token
    const result = await updateClientPost(token, props.post.id, formData)
    if(result.status == 200){
        $toast.open({
            message: 'Successfully updated client post',
            type: 'success',
            duration: 3000
        })
        emit('refetch-clients')
        closeEdit()
    } else {
        $toast.open({
            message: 'Error, could not update client post',
            type: 'error',
            duration: 3000
        })
    }
}

function openEdit(){
    isEditable.value = true
}

function closeEdit(){
    isEditable.value = false
}

async function archive(){
    const token = store.state.auth.token
    const result = await archiveClientPost(token, props.post.id)
    if(result.status == 200){
        $toast.open({
            message: 'Successfully archived client post',
            type: 'success',
            duration: 3000
        })
        emit('refetch-clients')
    } else {
        $toast.open({
            message: 'Error, could not archive client post',
            type: 'error',
            duration: 3000
        })
    }
}

</script>